module.exports = __webpack_public_path__ + "static/media/lcg-shape-purple-down.6c29d23b.svg";